import React from 'react';
import { WHATSAPP_LINK, CALL_LINK } from '../data/mockData';
import { Phone, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* Call Now Button */}
      <motion.a
        href={CALL_LINK}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-[#D4A843] shadow-lg shadow-[#D4A843]/30 hover:shadow-[#D4A843]/50 transition-shadow duration-300"
        title="Call Now"
      >
        <Phone size={22} className="text-[#1C1C1C]" />
        {/* Tooltip */}
        <span className="absolute right-full mr-3 bg-[#2A2A2A] text-[#F5F0E8] text-xs px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Call Now
        </span>
      </motion.a>

      {/* WhatsApp Book Now Button */}
      <motion.a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2.2, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50 transition-shadow duration-300"
        title="Book on WhatsApp"
      >
        <MessageCircle size={22} className="text-white" />
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        {/* Tooltip */}
        <span className="absolute right-full mr-3 bg-[#2A2A2A] text-[#F5F0E8] text-xs px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Book on WhatsApp
        </span>
      </motion.a>
    </div>
  );
};

export default FloatingButtons;
